module.exports = __webpack_public_path__ + "static/media/fee-profile.9bd12e6e.svg";